export class MockChangeEvent {
  target = null

  constructor(target) {
    this.target = target
  }
}
